// extracted by mini-css-extract-plugin
export default {"container":"Verification_container__cXH2y","description":"Verification_description__veLON"};